import { ImgHTMLAttributes, SourceHTMLAttributes } from "react";

// eslint-disable-next-line no-restricted-imports
import { css } from "@emotion/react";

export type AspectRatios = "1/1" | "2/1" | "16/9" | "3/2" | "4/3" | "none";

export interface ImageProps extends ImgHTMLAttributes<HTMLImageElement> {
    src: string;
    alt: string;
    aspectRatio?: AspectRatios;
}

const imageCSS = (ratio?: string) => css`
    max-width: 100%;
    ${ratio && ratio !== "none"
        ? `
    aspect-ratio: ${ratio};
    object-fit: cover;
    width: 100%;
  `
        : ""}
`;

/**
 * @deprecated - Please use Picture instead
 */
export const Image = ({ src, alt, aspectRatio, ...rest }: ImageProps) => {
    return <img src={src} alt={alt} css={imageCSS(aspectRatio)} {...rest} />;
};

export type PictureProps = {
    sources?: Array<SourceHTMLAttributes<HTMLSourceElement>>;
    image: ImageProps;
};

export const Picture = ({
    sources,
    image: { src, alt, aspectRatio, ...image }
}: PictureProps) => {
    return sources ? (
        <picture>
            {sources.map((source, index) => (
                <source key={index} {...source} />
            ))}
            <img {...image} src={src} alt={alt} css={imageCSS(aspectRatio)} />
        </picture>
    ) : (
        <img {...image} src={src} alt={alt} css={imageCSS(aspectRatio)} />
    );
};
